"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCachingMapPromiseDebouncer = createCachingMapPromiseDebouncer;
function createCachingMapPromiseDebouncer(duration) {
    const map = new Map();
    return (key, func) => {
        const keyStr = JSON.stringify(key);
        let value = map.get(keyStr);
        if (!value) {
            value = func();
            map.set(keyStr, value);
            setTimeout(() => map.delete(keyStr), duration);
        }
        return value;
    };
}
//# sourceMappingURL=promise-debounce.js.map